export const TERMOS_VERSAO = '1.0';
export const PRIVACIDADE_VERSAO = '1.2';
export const ULTIMA_ATUALIZACAO = '19/08/2026';

export const EMPRESA = {
  nome: 'Demiplie Doces LTDA',
  cnpj: '52.742.065/0001-06',
  endereco: 'Rua Barata Ribeiro, 466 - Vila Itapura - Campinas - SP - 13023-030',
  email: 'contato@demiplie.com.br',
};

export const TERMOS_USO = `Ao acessar, cadastrar-se ou utilizar o Metria, a usuária declara que leu, compreendeu e concorda integralmente com os presentes Termos de Uso. Caso não concorde, não deverá utilizar a plataforma.

1. OBJETO
O Metria — Assistente para Confeiteiras é uma plataforma digital (SaaS) destinada à gestão de negócios de confeitaria, oferecendo funcionalidades como:
• Cadastro de ingredientes e fichas técnicas
• Controle de estoque e lotes
• Gestão de insumos, embalagens e recheios
• Cadastro de tamanhos de bolo e menu fixo
• Guia de produção semanal e montagem diária
• Gestão de pedidos, clientes e orçamentos
• Precificação de produtos
• Relatórios financeiros e de movimentação

2. ACEITAÇÃO DOS TERMOS
O uso da plataforma está condicionado à aceitação expressa destes Termos de Uso e da Política de Privacidade, mediante consentimento eletrônico ativo da usuária.

3. CADASTRO E RESPONSABILIDADE DA USUÁRIA
3.1. A usuária é responsável pela veracidade das informações fornecidas.
3.2. É de responsabilidade da usuária:
• Manter seus dados atualizados
• Proteger suas credenciais de acesso (login via Google)
• Todas as ações realizadas em sua conta
3.3. O compartilhamento de login é proibido.

4. USO DA PLATAFORMA
É vedado à usuária:
• Utilizar o sistema para fins ilegais
• Praticar engenharia reversa
• Copiar, explorar ou redistribuir o sistema
• Violar a segurança da plataforma
• Inserir conteúdo ofensivo, fraudulento ou que viole direitos de terceiros

5. FUNCIONALIDADE E LIMITAÇÃO DE RESPONSABILIDADE
O Metria é uma ferramenta de apoio à gestão, não se responsabilizando por:
• Decisões comerciais da usuária
• Resultados financeiros
• Lucros cessantes
• Perdas operacionais
• Erros de uso
• Informações inseridas incorretamente

6. PLANOS, ASSINATURAS E PAGAMENTOS
A plataforma poderá oferecer planos gratuitos e pagos. Valores, recursos e condições estarão descritos na própria plataforma. Cancelamentos e renovações seguem as regras do sistema contratado.

7. ARMAZENAMENTO DE DADOS
Os dados são armazenados em infraestrutura de nuvem, podendo estar localizados em servidores no Brasil ou em outros países, sempre respeitando as leis de proteção de dados aplicáveis.

8. PROPRIEDADE INTELECTUAL
Todo o sistema, marca, layout, identidade visual, código, funcionalidades e estrutura pertencem exclusivamente ao Metria / ${EMPRESA.nome}, sendo proibida qualquer reprodução sem autorização expressa.

9. SUSPENSÃO E ENCERRAMENTO
O Metria poderá suspender ou encerrar contas que:
• Violem estes termos
• Pratiquem uso indevido
• Comprometam a segurança
• Infrinjam leis aplicáveis

10. ALTERAÇÕES DOS TERMOS
Os Termos podem ser alterados a qualquer momento. O uso contínuo da plataforma após atualização representa concordância automática. Mudanças relevantes serão comunicadas à usuária.

11. JURISDIÇÃO E LEGISLAÇÃO APLICÁVEL
Estes Termos são regidos pelas leis brasileiras. Fica eleito o foro da Comarca de Campinas/SP para dirimir eventuais controvérsias, respeitando legislações internacionais de proteção de dados (LGPD e GDPR).

12. EMPRESA RESPONSÁVEL
${EMPRESA.nome}
CNPJ: ${EMPRESA.cnpj}
Endereço: ${EMPRESA.endereco}

13. CONTATO
Para suporte, dúvidas ou solicitações:
✉ ${EMPRESA.email}`;


export const POLITICA_PRIVACIDADE = `Esta Política de Privacidade descreve como o Metria coleta, utiliza, armazena, processa e protege os dados das usuárias em conformidade com a LGPD (Lei nº 13.709/2018), GDPR e normas internacionais de proteção de dados.

1. DADOS COLETADOS
1.1 Dados fornecidos pela usuária:
• Nome
• E-mail
• Telefone (opcional)
• Dados do negócio (nome da confeitaria)
• Informações de receitas e fichas técnicas
• Produtos e estoque
• Pedidos e orçamentos
• Dados de clientes (cadastrados pela usuária)
• Relatórios financeiros

1.2 Dados coletados automaticamente:
• Endereço IP
• Dados de navegação e uso
• Registros de acesso (logs)
• Informações do dispositivo

2. FINALIDADE DO TRATAMENTO DOS DADOS
Os dados são utilizados para:
• Funcionamento da plataforma
• Gestão de contas
• Autenticação (via Google OAuth)
• Suporte à usuária
• Segurança do sistema
• Melhoria contínua do serviço
• Comunicação (avisos, alertas, atualizações)
• Funcionamento da assistente Mai, que lê fotos, planilhas e mensagens enviadas pela usuária para cadastrar ingredientes, embalagens e fichas técnicas
• Análises internas agregadas
• Cumprimento de obrigação legal

3. BASE LEGAL DE TRATAMENTO
Os dados são tratados com base em:
• Consentimento da usuária
• Execução de contrato
• Cumprimento de obrigação legal
• Interesse legítimo da plataforma
Em conformidade com os artigos 7º e 11 da LGPD, bem como o GDPR.

4. ARMAZENAMENTO E SEGURANÇA
Os dados são armazenados em servidores de nuvem com criptografia em trânsito (HTTPS/TLS) e em repouso. A plataforma adota medidas técnicas e organizacionais razoáveis para proteger os dados contra acesso não autorizado, perda, alteração ou destruição.

5. TRANSFERÊNCIA INTERNACIONAL DE DADOS
Os dados poderão ser armazenados e processados em servidores localizados em diferentes países, respeitando as leis de proteção de dados aplicáveis e padrões internacionais de segurança. Os operadores listados em 6.1 — entre eles Railway, Google Cloud, Cloudinary, Sentry, Resend e Anthropic — mantêm servidores fora do Brasil, principalmente nos Estados Unidos e na União Europeia. A transferência se dá com base no artigo 33 da LGPD, para a execução do contrato firmado com a usuária.

6. COMPARTILHAMENTO DE DADOS
O Metria não comercializa dados pessoais. O compartilhamento ocorre apenas:
• Por obrigação legal
• Por ordem judicial
• Com os operadores listados em 6.1, estritamente para a operação do serviço
• Com consentimento expresso da usuária

6.1. OPERADORES QUE TRATAM DADOS EM NOSSO NOME
• Railway — hospedagem da aplicação e do banco de dados
• Google Cloud / Firebase — autenticação com conta Google e envio de notificações push (o token do aparelho é tratado como identificador)
• Cloudinary — armazenamento das fotos de referência que a usuária anexa a pedidos
• Sentry — registro de erros da aplicação, incluindo e-mail e identificador da confeitaria, para diagnóstico de falhas
• Resend — envio de e-mails transacionais (alertas, recuperação de senha)
• Pagar.me — processamento de pagamentos das assinaturas contratadas pelo site. Os dados de cartão são enviados diretamente ao processador e não trafegam pelos nossos servidores
• Apple App Store e Google Play — quando a assinatura é contratada dentro do aplicativo, a cobrança e os dados de pagamento ficam sob responsabilidade da loja, conforme a política dela
• Anthropic (Claude) — processa o conteúdo que a usuária envia à assistente Mai: fotos de notas fiscais, embalagens e produtos, planilhas anexadas e o texto da conversa. O envio só acontece quando a usuária usa a assistente. O conteúdo não é utilizado para treinar modelos de inteligência artificial

Cada operador trata os dados apenas para a finalidade acima e conforme instruções
da Demiplie Doces LTDA.

7. DIREITOS DA USUÁRIA (LGPD)
A usuária possui direito de:
• Acesso aos seus dados
• Correção de dados incompletos, inexatos ou desatualizados
• Atualização
• Anonimização, bloqueio ou eliminação de dados desnecessários
• Portabilidade
• Eliminação dos dados pessoais tratados com consentimento
• Revogação do consentimento
• Informação sobre compartilhamento de dados
• Oposição ao tratamento realizado com fundamento em hipótese dispensada de consentimento

Para exercer esses direitos, entre em contato pelo e-mail abaixo.

8. RETENÇÃO DE DADOS
Os dados são mantidos enquanto:
• A conta estiver ativa
• Forem necessários ao funcionamento da plataforma
• Forem exigidos por lei ou regulamentação

Após o encerramento da conta, os dados podem ser mantidos por período adicional para cumprimento de obrigações legais, prescrição de direitos ou defesa em processos.

9. COOKIES E TECNOLOGIAS
A plataforma pode utilizar cookies e tecnologias similares para:
• Desempenho
• Segurança
• Análise de uso
• Melhoria de experiência
• Funcionamento técnico essencial (autenticação, sessão)

10. MENORES DE IDADE
A plataforma é destinada a maiores de 18 anos. Não coletamos intencionalmente dados de menores.

11. ALTERAÇÕES NA POLÍTICA
Esta política pode ser atualizada a qualquer momento. Mudanças relevantes serão comunicadas às usuárias pelos canais disponíveis na plataforma.

12. ENCARREGADO DE DADOS (DPO)
${EMPRESA.nome}
CNPJ: ${EMPRESA.cnpj}
Endereço: ${EMPRESA.endereco}

13. CONTATO DE PRIVACIDADE
Para assuntos relacionados à privacidade, proteção de dados ou exercício de direitos:
✉ ${EMPRESA.email}`;
